import React, { useState } from "react";
import { Box, IconButton, Dialog, Typography } from "@mui/material";
import {
    ArrowBackIosNew,
    ArrowForwardIos,
    Close,
} from "@mui/icons-material";
import { motion } from "framer-motion";
// import Image_4 from "../images/Image-4.webp";
// import Image_11 from "../images/Image-11.webp";
// import Image_2 from "../images/Image-2.webp";
// import Image_3 from "../images/Image-3b.webp";
// import Image_Apurva from "../images/Image-Apurva.webp";
// import Image_Nitesh from "../images/Image-Nitesh.webp";
// import Image_Shayan from "../images/Image-Shayan.webp";
import WasilSuccessStory from '../../components/images/wasil-success-story.jpg';
import AnantSuccessStory from '../../components/images/anant-success-story.jpg';
import ApurvaSuccessStory from '../../components/images/apura-success-story.jpg';
import AyushSuccessStory from '../../components/images/ayush-success-story.jpg';
import ShayanSuccessStory from '../../components/images/shyan_youtube.webp';
import NileshSuccessStory from '../../components/images/NileshVideo.webp';
import EyonSuccessStory from '../../components/images/EyonSuccessStory.webp';
import ShubhSuccessStory from '../images/ShubSuccessStory.webp';
import Deeksha from '../images/Deeksha.webp';
import Sohail from '../images/Sohail.webp';
import Yuvanandhan from '../images/Yuvanandhan.webp';
import ArkoMirta from '../images/Arko Mitra.webp';
import Sandesh from '../images/Sandesh.webp';
import Anirudha from '../images/Anirudha.webp';
import Kshitija from '../images/Kshitija.webp';

const slides = [
    {
        thumb: Anirudha,
        video: "https://www.youtube.com/embed/zK38PD3SE7E?si=FZWyBM6gbXEAvpfc",
    },
    {
        thumb: Kshitija,
        video: "https://www.youtube.com/embed/73Q0VgbLzIk?si=zwvZq7QupN5XsuEs",
    },
    {
        thumb: Sohail,
        video: "https://www.youtube.com/embed/8Q4afwvEA3s?si=uAATy_9XcW5BANdr",
    },
    {   
        thumb: Yuvanandhan,
        video: "https://www.youtube.com/embed/LHlt1OpqREM?si=CWD-jKmeT8DRrWdO",
    },
    {
        thumb: ArkoMirta,
        video: "https://www.youtube.com/embed/9xAkid_F3Ao?si=PdZ-0pISXo7KihJZ",
    },
    {
        thumb: EyonSuccessStory,
        video: "https://www.youtube.com/embed/4QX7UEgL6Ag?si=U_qR9QjrBW2Mns6J",
    },
    {
        thumb: AnantSuccessStory,
        video: "https://www.youtube.com/embed/eA6r4AocL9g?si=tdzPMX3gPaYA-BHU",
    },
    {
        thumb: AyushSuccessStory,
        video: "https://www.youtube.com/embed/Vx-Xs-2_75o?si=tcbvD0sVHWfjE7kd",
    },
    {
        thumb: ApurvaSuccessStory,
        video: "https://www.youtube.com/embed/DrID61L12Pc?si=IJBy_DEeKzzuyKc8",
    },
    {
        thumb: NileshSuccessStory,
        video: "https://www.youtube.com/embed/nC4B0DqEu38?si=Qk78AoGTU2qj6FQW",
    },
    {
        thumb: WasilSuccessStory,
        video: "https://www.youtube.com/embed/HiQo4aDUWfs?si=C1BygYDbKNF47ICh",
    },
    {
        thumb: ShayanSuccessStory,
        video: "https://www.youtube.com/embed/t0l52vDZOLE?si=8h27oIG_L1xbsgAN",
    },
    { 
        thumb: ShubhSuccessStory,
        video: "https://www.youtube.com/embed/8BrjUoPSIBE?si=fQSagBt73n7QJvqX",
    },
    {
        thumb: Sandesh,
        video: "https://www.youtube.com/embed/ITApXi7175E?si=8A7lMM_im0hgpJ-I",
    },
    {
        thumb: Deeksha,
        video: "https://www.youtube.com/embed/EL8UXQogy80?si=NFd5vUSjFArtY6Lj",
    },
];

/**
 * Scale logic
 */
const getScale = (offset, active) => {
    if (active) return 1.1; // clicked card grows
    if (offset === 0) return 1;
    if (Math.abs(offset) === 1) return 0.75;
    if (Math.abs(offset) === 2) return 0.5;
    return 0;
};

export default function YouTubeVideoCarousel(props) {
    const { isSmallScreen } = props;
    const dots = Array.from({ length: slides.length });

    const renderDots = () => (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                mt: 2,
            }}
        >
            {dots.map((_, index) => (
                <Box
                    key={index}
                    sx={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        backgroundColor: index === centerIndex ? "#494949" : "#ccc",
                        margin: "0 4px",
                        cursor: "pointer",
                        transition: "background-color 0.3s",
                    }}
                    onClick={() => setCenterIndex(index)}
                />
            ))}
        </Box>
    );
    const [centerIndex, setCenterIndex] = useState(0);
    const [activeIndex, setActiveIndex] = useState(null);
    const [open, setOpen] = useState(false);

    const handlePrev = () => {
        setCenterIndex((prev) => (prev - 1 + slides.length) % slides.length);
    };

    const handleNext = () => {
        setCenterIndex((prev) => (prev + 1) % slides.length);
    };

    return (
        <>
            <Typography
                variant={isSmallScreen ? "h5" : "h4"}
                sx={{
                    fontWeight: 700,
                    textAlign: "center",
                    mb: isSmallScreen ? 1 : 0,
                    mt: isSmallScreen ? 6 : 12,
                    fontFamily: "Poppins, sans-serif",
                }}
            >
                Our Success Stories
            </Typography>

            <Box
                sx={{
                    position: "relative",
                    width: isSmallScreen ? "95%" : "70%",
                    height: isSmallScreen ? 200 : 350,
                    margin: "auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                }}
            >
                {/* Left Arrow */}
                <IconButton
                    aria-label="Previous Slide"
                    onClick={handlePrev}
                    sx={{
                        position: "absolute", left: 10, zIndex: 50, color: "#fff", backgroundColor: "#494949",
                        "&:hover": {
                            background: "rgba(0,0,0,0.8)",
                            transform: "scale(1.1)",
                        },
                    }}
                >
                    <ArrowBackIosNew />
                </IconButton>

                {/* Right Arrow */}
                <IconButton
                    aria-label="Next Slide"
                    onClick={handleNext}
                    sx={{
                        position: "absolute", right: 10, zIndex: 50, color: "#fff", backgroundColor: "#494949",
                        "&:hover": {
                            background: "rgba(0,0,0,0.8)",
                            transform: "scale(1.1)",
                        },
                    }}
                >
                    <ArrowForwardIos />
                </IconButton>

                {slides.map((item, i) => {
                    let offset = i - centerIndex;

                    if (offset > slides.length / 2) offset -= slides.length;
                    if (offset < -slides.length / 2) offset += slides.length;

                    const isActive = activeIndex === i;
                    const scale = getScale(offset, isActive);
                    if (scale === 0) return null;

                    const zIndex = isActive
                        ? 40
                        : offset === 0
                            ? 30
                            : Math.abs(offset) === 1
                                ? 20
                                : 10;

                    return (
                        <motion.div
                            key={i}
                            style={{ position: "absolute", zIndex, cursor: "pointer" }}
                            animate={{
                                scale,
                                x:
                                    offset === 0
                                        ? 0
                                        : offset === 1
                                            ? isSmallScreen ? 50 : 220
                                            : offset === -1
                                                ? isSmallScreen ? -50 : -220
                                                : offset === 2
                                                    ? isSmallScreen ? 90 : 300
                                                    : isSmallScreen ? -90 : -300,
                            }}
                            transition={{ type: "spring", stiffness: 260, damping: 28 }}
                            onClick={() => {
                                setActiveIndex(i);
                                setOpen(true);
                            }}
                        >
                            <Box
                                sx={{
                                    width: isSmallScreen ? 200 : 420,
                                    height: isSmallScreen ? 150 : 260,
                                    borderRadius: 3,
                                    overflow: "hidden",
                                    background: "#000",
                                    boxShadow: 10,
                                    position: "relative",
                                }}
                            >
                                {/* Thumbnail */}
                                <img
                                    loading="lazy"
                                    src={item.thumb}
                                    alt="thumbnail"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                    }}
                                />

                                {/* Play Button Overlay */}
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 64,
                                        height: 64,
                                        borderRadius: "50%",
                                        background: "rgba(0,0,0,0.6)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        pointerEvents: "none",
                                    }}
                                >
                                    <svg
                                        width="28"
                                        height="28"
                                        viewBox="0 0 24 24"
                                        fill="white"
                                    >
                                        <path d="M8 5v14l11-7z" />
                                    </svg>
                                </Box>
                            </Box>
                        </motion.div>
                    );
                })}
            </Box>
            {renderDots()}

            {/* ================= POPUP PLAYER ================= */}
            <Dialog
                open={open}
                onClose={() => {
                    setOpen(false);
                    setActiveIndex(null);
                }}
                maxWidth={false}
                PaperProps={{
                    sx: {
                        width: isSmallScreen ? "95%" : "70vw", // ✅ works on phone & desktop
                        maxWidth: "100%",
                        background: "#000",
                        borderRadius: 3,
                    },
                }}
            >
                <Box sx={{ position: "relative", paddingTop: "56.25%" }}>
                    {/* Close Button */}
                    <IconButton
                        aria-label="Close Video"
                        onClick={() => {
                            setOpen(false);
                            setActiveIndex(null);
                        }}
                        sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            zIndex: 10,
                            color: "#fff",
                            background: "rgba(0,0,0,0.6)",
                        }}
                    >
                        <Close />
                    </IconButton>

                    {/* Video */}
                    {activeIndex !== null && (
                        <iframe
                            src={`${slides[activeIndex].video}?autoplay=1`}
                            title="YouTube Player"
                            allow="autoplay; encrypted-media"
                            allowFullScreen
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                border: 0,
                            }}
                        />
                    )}
                </Box>
            </Dialog>
        </>
    );
}
